import Image from 'next/image'
import styles from './Author.module.css'

function Author() {
  return (
    <div className={styles.aboutAuthor}>
      <Image
        src="/gleb-square.jpeg"
        width="200"
        height="200"
        alt="Gleb Bahmutov photo"
        data-cy="author-photo"
      />
      <div className={styles.description}>
        <b>About the author:</b> Gleb Bahmutov spent 4 years working on the
        Cypress Test Runner itself, has written{' '}
        <a href="https://glebbahmutov.com/blog/tags/cypress/">
          200+ Cypress blog posts
        </a>{' '}
        and recorded{' '}
        <a href="https://www.youtube.com/playlist?list=PLP9o9QNnQuAYYRpJzDNWpeuOVTwxmIxcI">
          300+ free Cypress videos
        </a>{' '}
        in addition to writing the course above.
      </div>
    </div>
  )
}

export default Author
